import { render, staticRenderFns } from "./suitch-tracker.vue?vue&type=template&id=3dd71c4a&"
import script from "./suitch-tracker.vue?vue&type=script&lang=js&"
export * from "./suitch-tracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports